import { apiBaseQuery } from '../../api/services/rtkQuery/apiBaseQuery';
import { postSignupMutation } from './queries';
export var signupApi = apiBaseQuery.injectEndpoints({
  endpoints: function endpoints(builder) {
    return {
      postSignup: builder.mutation(postSignupMutation)
    };
  }
});
signupApi.enhanceEndpoints({
  addTagTypes: ['Signup']
});
var usePostSignupMutation = signupApi.usePostSignupMutation;
export { usePostSignupMutation };